import { useEffect } from 'react'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, toggle,
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Forms 
    Forms,
    //------------- FetchData
    FetchData
}) => {

    const _fetchDepositsByFilter = async ({ startDate, endDate, idbanco }) => {
        if (!startDate) return
        if (!endDate) return

        const normalized = {
            startDate,
            endDate,
            idbanco: (!idbanco || idbanco === 'ALL') ? null : Number(idbanco),
        }

        const { fetchBankDeposits } = FetchData
        fetchBankDeposits.setParamsToSearch(normalized)
        fetchBankDeposits.executeFetch()
    }

    const handleChangeStartDate = (event) => {
        const { FilterForm } = Forms
        const { formState, setFormState } = FilterForm

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }))

        const { endDate, idbanco } = formState
        _fetchDepositsByFilter({ startDate: value, endDate, idbanco })
    }

    const handleChangeEndDate = (event) => {
        const { FilterForm } = Forms
        const { formState, setFormState } = FilterForm

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }))

        const { startDate, idbanco } = formState
        _fetchDepositsByFilter({ startDate, endDate: value, idbanco })
    }

    const handleChangeIdbanco = (event) => {
        const { FilterForm } = Forms
        const { formState, setFormState } = FilterForm

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }))

        const { startDate, endDate } = formState
        _fetchDepositsByFilter({ startDate, endDate, idbanco: value })
    }

    const onSubmitFilterForm = (e) => {
        e.preventDefault()
        const { FilterForm } = Forms
        const { formState } = FilterForm
        const { startDate, endDate, idbanco } = formState
        _fetchDepositsByFilter({ startDate, endDate, idbanco })
    }

    useEffect(() => {
        const { FilterForm } = Forms
        const { formState } = FilterForm
        _fetchDepositsByFilter(formState)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleClickShowDeposit = (rowData) => {
        const { setShowForm, setModalOpeningMode } = globalStates
        const { FormScreen } = Forms
        const { setFormState } = FormScreen

        setFormState(rowData)
        setModalOpeningMode('READONLY')
        setShowForm(true)
    }

    const handleClickHideForm = () => {
        const { setShowForm } = globalStates
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        setShowForm(false)
    }

    const handleClickDownloadBoleta = async (customFileName, openUrl) => {
        if (!openUrl) {
            toast.warn('No hay boleta disponible para descargar', { position: 'top-right', theme: 'colored' })
            return
        }

        try {
            const response = await fetch(openUrl)
            const blob = await response.blob()

            const enlaceTemporal = document.createElement('a')
            enlaceTemporal.href = window.URL.createObjectURL(blob)
            enlaceTemporal.download = customFileName || 'boleta'
            document.body.appendChild(enlaceTemporal)
            enlaceTemporal.click()
            document.body.removeChild(enlaceTemporal)

            toast.success('Se ha descargado la boleta', { position: 'top-right', theme: 'colored' })
        } catch (error) {
            console.log('Download error:', error)
            toast.warn('Error al descargar la boleta', { position: 'top-right', theme: 'colored' })
        }
    }

    const handleClickApproveDeposit = async (e) => {
        e.preventDefault()
        const { FormScreen, FilterForm } = Forms
        const { formState } = FormScreen

        const aprobacionCheck = String(formState.aprobacion_check ?? '').trim().toUpperCase()
        if (!['APROBADO', 'RECHAZADO'].includes(aprobacionCheck)) {
            toast.warn('Solo se permite guardar con estado APROBADO o RECHAZADO', { position: 'top-right', theme: 'colored', autoClose: false })
            return
        }

        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        const _dataBody = {
            id: formState.id,
            origen: formState.origen,
            aprobacion_check: aprobacionCheck,
            aprobacion_referencia_ach: formState.aprobacion_referencia_ach || null,
            aprobacion_observaciones: formState.aprobacion_observaciones || null,
            aprobacion_usuario: user.username,
            aprobacion_fecha: Helpers.getCurrentDate(),
        }

        try {
            const { data } = await marvarApi.put('/bank/deposits/save-approval', _dataBody)

            if (data?.flag === 'OK') {
                if (aprobacionCheck === 'APROBADO') {
                    toast.success(data.message || 'Deposito aprobado correctamente', { position: 'top-right', theme: 'colored' })
                } else if (aprobacionCheck === 'RECHAZADO') {
                    toast.error(data.message || 'Deposito rechazado', { position: 'top-right', theme: 'colored' })
                } else {
                    toast.success(data.message || 'Estado guardado correctamente', { position: 'top-right', theme: 'colored' })
                }

                _fetchDepositsByFilter(FilterForm.formState)
                handleClickHideForm()
            } else {
                toast.warn(data?.message || 'No se pudo guardar la aprobacion', { position: 'top-right', theme: 'colored', autoClose: false })
            }
        } catch (error) {
            console.log('[handleClickApproveDeposit] error:', error)
            toast.error('Error al guardar la aprobacion. Notifique a Soporte técnico.', { position: 'top-right', theme: 'colored', autoClose: false })
        }
    }

    const handleClickPrintBankReport = () => {

        const { FilterForm } = Forms
        const { formState } = FilterForm

        const { startDate, endDate, idbanco } = formState

        if (!startDate) {
            toast.warn('No es posible descargar sin especificar la fecha de inicio para generar el reporte', {
                position: 'top-right',
                theme: 'colored'
            })
            return
        }

        if (!endDate) {
            toast.warn('No es posible descargar sin especificar la fecha de fin para generar el reporte', {
                position: 'top-right',
                theme: 'colored'
            })
            return
        }

        const { fetchBankDepositsReport } = FetchData

        fetchBankDepositsReport.setParamsToSearch({
            startDate,
            endDate,
            idbanco
        })

        fetchBankDepositsReport.executeFetch()
    }


    // ======================================================================================
    // Movimientos manuales (INGRESO / EGRESO) -> bancos_movimientos
    // ======================================================================================

    const _escapeHtml = (value) => String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')

    const _fetchMovementsByFilter = ({ startDate, endDate, idbanco, movimiento_tipo }) => {
        if (!startDate) return
        if (!endDate) return

        const { fetchBankMovements } = FetchData
        fetchBankMovements.setParamsToSearch({
            startDate,
            endDate,
            idbanco: (!idbanco || idbanco === 'ALL') ? 'ALL' : Number(idbanco),
            movimiento_tipo: (!movimiento_tipo || movimiento_tipo === 'MOVIMIENTOS') ? 'ALL' : movimiento_tipo,
        })
        fetchBankMovements.executeFetch()
    }

    const _changeFilterMovements = (event) => {
        const { FilterMovements } = Forms
        const { formState, setFormState } = FilterMovements
        const { name, value } = event.target

        setFormState(prev => ({ ...prev, [name]: value }))
        _fetchMovementsByFilter({ ...formState, [name]: value })
    }

    const handleClickPrintMovementReceipt = (rowData) => {
        Helpers.drawBankMovementReceipt(rowData)
    }

    const handleClickPrintMovementsReport = () => {
        const { startDate, endDate, idbanco, movimiento_tipo } = Forms.FilterMovements.formState

        if (!startDate || !endDate) {
            toast.warn('No es posible imprimir sin especificar la fecha de inicio y la fecha fin', {
                position: 'top-right',
                theme: 'colored'
            })
            return
        }

        const { fetchBankMovementsReport } = FetchData
        fetchBankMovementsReport.setParamsToSearch({
            startDate,
            endDate,
            idbanco: (!idbanco || idbanco === 'ALL') ? 'ALL' : Number(idbanco),
            movimiento_tipo: (!movimiento_tipo || movimiento_tipo === 'MOVIMIENTOS') ? 'ALL' : movimiento_tipo,
        })
        fetchBankMovementsReport.executeFetch()

        toggle('', 'VISOR DE REPORTE', 'ReportViewer', {})
    }

    const handleChangeMovementStartDate = (event) => _changeFilterMovements(event)
    const handleChangeMovementEndDate = (event) => _changeFilterMovements(event)
    const handleChangeMovementIdbanco = (event) => _changeFilterMovements(event)
    const handleChangeMovementTipoFilter = (event) => _changeFilterMovements(event)

    const onSubmitFilterMovements = (e) => {
        e.preventDefault()
        _fetchMovementsByFilter(Forms.FilterMovements.formState)
    }

    const _calculateTotals = ({ movimiento_moneda, clean_monto, clean_tc }) => {
        const { FormMovement } = Forms
        const { setFormState } = FormMovement
        const { formatMoney } = Helpers

        const monto = Number(clean_monto)
        const tc = Number(clean_tc)

        if (!movimiento_moneda || isNaN(monto) || isNaN(tc) || tc === 0) {
            setFormState(prev => ({
                ...prev,
                movimiento_quetzales: '',
                movimiento_dolares: '',
                clean_movimiento_quetzales: 0,
                clean_movimiento_dolares: 0,
            }))
            return
        }

        // Sin conversion: el total de la moneda contraria queda en 0 (igual que Cajas)
        const q = movimiento_moneda === 'QUETZAL' ? monto : 0
        const usd = movimiento_moneda === 'DOLAR' ? monto : 0

        setFormState(prev => ({
            ...prev,
            movimiento_quetzales: formatMoney(q),
            movimiento_dolares: formatMoney(usd),
            clean_movimiento_quetzales: Number(q.toFixed(2)),
            clean_movimiento_dolares: Number(usd.toFixed(2)),
        }))
    }

    const handleChangeMovementAmount = (event) => {
        const { FormMovement } = Forms
        const { formState, onInputChangeForNumber } = FormMovement

        onInputChangeForNumber(event)
        _calculateTotals({
            movimiento_moneda: formState.movimiento_moneda,
            clean_monto: Helpers.convertToFloat(event.target.value),
            clean_tc: formState.clean_movimiento_tipo_cambio,
        })
    }

    const handleChangeMovementCurrency = (event) => {
        const { FormMovement } = Forms
        const { formState, setFormState } = FormMovement
        const { name, value } = event.target

        setFormState(prev => ({ ...prev, [name]: value }))
        _calculateTotals({
            movimiento_moneda: value,
            clean_monto: formState.clean_movimiento_monto,
            clean_tc: formState.clean_movimiento_tipo_cambio,
        })
    }

    const handleChangeMovementExchangeRate = (event) => {
        const { FormMovement } = Forms
        const { formState, onInputChangeForNumber } = FormMovement

        onInputChangeForNumber(event)
        _calculateTotals({
            movimiento_moneda: formState.movimiento_moneda,
            clean_monto: formState.clean_movimiento_monto,
            clean_tc: Helpers.convertToFloat(event.target.value),
        })
    }

    const handleClickOpenMovementForm = () => {
        const { setShowMovementForm, setModalOpeningMode } = globalStates
        setModalOpeningMode('EDITABLE')
        setShowMovementForm(true)
    }

    // Opciones -> Informacion: abre el formulario en modo lectura con los datos de la fila
    const handleClickShowMovement = (rowData) => {
        const { setShowMovementForm, setModalOpeningMode } = globalStates
        const { FormMovement } = Forms
        const { formatMoney } = Helpers

        // La fecha llega como dd-mm-yyyy; el input date necesita yyyy-mm-dd
        const [dd, mm, yyyy] = String(rowData.movimiento_fecha ?? '').split('-')

        FormMovement.setFormState({
            ...FormMovement.formState,
            idbanco: rowData.idbanco,
            movimiento_fecha: yyyy ? `${yyyy}-${mm}-${dd}` : '',
            movimiento_tipo: rowData.movimiento_tipo,
            movimiento_monto: formatMoney(rowData.movimiento_monto),
            movimiento_moneda: rowData.movimiento_moneda,
            movimiento_tipo_cambio: formatMoney(rowData.movimiento_tipo_cambio),
            movimiento_quetzales: formatMoney(rowData.movimiento_quetzales),
            movimiento_dolares: formatMoney(rowData.movimiento_dolares),
            movimiento_observaciones: rowData.movimiento_observaciones ?? '',
            boleta_numero: rowData.boleta_numero ?? '',
            aprobacion_referencia_ach: rowData.aprobacion_referencia_ach ?? '',
            boleta_foto_originalname: rowData.boleta_foto_originalname ?? '',
            boleta_foto_path: rowData.boleta_foto_path ?? '',
            acceptedFiles: [],
            fileRejections: [],
        })

        setModalOpeningMode('READONLY')
        setShowMovementForm(true)
    }

    const handleClickHideMovementForm = () => {
        const { setShowMovementForm } = globalStates
        const { FormMovement } = Forms

        FormMovement.onResetForm()
        setShowMovementForm(false)
    }

    const handleChangeTab = (_, newTab) => {
        const { setActiveTab } = globalStates
        setActiveTab(newTab)
    }

    const onSubmitMovementForm = async (e) => {
        e.preventDefault()

        const { FormMovement, FilterMovements } = Forms
        const { formState } = FormMovement
        const { setLoadingSubmitForm } = globalStates
        const { fetchAllBanks } = FetchData
        const { formatMoney } = Helpers

        if (
            !formState.movimiento_tipo
            || !formState.idbanco
            || !formState.clean_movimiento_monto
            || !formState.movimiento_moneda
            || !formState.clean_movimiento_tipo_cambio
            || !String(formState.movimiento_observaciones ?? '').trim()
        ) {
            toast.warn('Para registrar la transacción debe completar todos los campos del formulario', {
                position: 'top-right', theme: 'colored', autoClose: false
            })
            return
        }

        if (!String(formState.boleta_numero ?? '').trim() || formState.acceptedFiles.length !== 1) {
            toast.warn('Debe ingresar el número de boleta y cargar el comprobante de depósito', {
                position: 'top-right', theme: 'colored', autoClose: false
            })
            return
        }

        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        // ---- Validacion banco / moneda (el backend la vuelve a validar)
        const bank = fetchAllBanks.banks.find(b => Number(b.idbanco) === Number(formState.idbanco))
        if (!bank) {
            toast.warn('El banco seleccionado no es válido', { position: 'top-right', theme: 'colored', autoClose: false })
            return
        }

        if (bank.currency_type !== formState.movimiento_moneda) {
            toast.warn(
                `No es posible operar la transacción, el banco seleccionado no admite el tipo de moneda "${formState.movimiento_moneda}", asegúrese de que su transacción sea del tipo "${bank.currency_type}"`,
                { position: 'top-right', theme: 'colored', autoClose: false }
            )
            return
        }

        // ---- Aviso de saldo insuficiente (informativo: el backend decide)
        const symbol = formState.movimiento_moneda === 'DOLAR' ? '$' : 'Q.'
        const saldo = Number(formState.movimiento_moneda === 'DOLAR' ? bank.saldo_dolares : bank.saldo_quetzales) || 0
        const saldoWarning = (formState.movimiento_tipo === 'EGRESO' && formState.clean_movimiento_monto > saldo)
            ? `<p style="color:#c0392b"><b>Atención:</b> el monto supera el saldo actual del banco (${symbol} ${formatMoney(saldo)}). El sistema rechazará la transacción.</p>`
            : ''

        // ---- Confirmacion previa al envio
        const confirmation = await Swal.fire({
            title: '¿La información es correcta?',
            icon: 'warning',
            html: `
                <div style="text-align:left; font-size:14px">
                    <p>Verifique que la información sea correcta. El movimiento se registrará como <b>APROBADO</b> y afectará el saldo del banco inmediatamente; no se podrá editar ni eliminar.</p>
                    <table style="width:100%">
                        <tr><td><b>Tipo</b></td><td>${_escapeHtml(formState.movimiento_tipo)}</td></tr>
                        <tr><td><b>Banco</b></td><td>${_escapeHtml(bank.nombre)}</td></tr>
                        <tr><td><b>Moneda del banco</b></td><td>${_escapeHtml(bank.currency_type)}</td></tr>
                        <tr><td><b>Monto</b></td><td>${symbol} ${formatMoney(formState.clean_movimiento_monto)}</td></tr>
                        <tr><td><b>Tipo de cambio</b></td><td>${formatMoney(formState.clean_movimiento_tipo_cambio)}</td></tr>
                        <tr><td><b>Total Q.</b></td><td>Q. ${formatMoney(formState.clean_movimiento_quetzales)}</td></tr>
                        <tr><td><b>Total $</b></td><td>$ ${formatMoney(formState.clean_movimiento_dolares)}</td></tr>
                        <tr><td><b>Boleta #</b></td><td>${_escapeHtml(formState.boleta_numero)}</td></tr>
                        <tr><td><b>Comprobante</b></td><td>${_escapeHtml(formState.acceptedFiles[0]?.name)}</td></tr>
                        <tr><td><b>Observaciones</b></td><td>${_escapeHtml(formState.movimiento_observaciones)}</td></tr>
                    </table>
                    ${saldoWarning}
                </div>`,
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Revisar',
            confirmButtonText: 'Sí, registrar',
        })

        if (!confirmation.isConfirmed) return

        const _dataBody = new FormData()
        _dataBody.append('idbanco', formState.idbanco)
        _dataBody.append('movimiento_fecha', formState.movimiento_fecha)
        _dataBody.append('movimiento_tipo', formState.movimiento_tipo)
        _dataBody.append('movimiento_monto', formState.clean_movimiento_monto)
        _dataBody.append('movimiento_moneda', formState.movimiento_moneda)
        _dataBody.append('movimiento_tipo_cambio', formState.clean_movimiento_tipo_cambio)
        _dataBody.append('movimiento_quetzales', formState.clean_movimiento_quetzales)
        _dataBody.append('movimiento_dolares', formState.clean_movimiento_dolares)
        _dataBody.append('movimiento_observaciones', formState.movimiento_observaciones)
        _dataBody.append('boleta_numero', String(formState.boleta_numero).trim())
        _dataBody.append('aprobacion_referencia_ach', formState.aprobacion_referencia_ach || '')
        _dataBody.append('user', user.username)
        formState.acceptedFiles.forEach(file => _dataBody.append('images', file))

        setLoadingSubmitForm(true)
        try {
            const { data } = await marvarApi.post('/bank/movements/create', _dataBody)

            if (data?.flag === 'OK') {
                toast.success(data.message, { position: 'top-right', theme: 'colored' })
                handleClickHideMovementForm()
                _fetchMovementsByFilter(FilterMovements.formState)
                fetchAllBanks.executeFetch() // refresca saldos
            } else {
                toast.warn(data?.message || 'No ha sido posible guardar el registro', {
                    position: 'top-right', theme: 'colored', autoClose: false
                })
            }
        } catch (error) {
            console.log('[onSubmitMovementForm] error:', error)
            toast.error('Error al guardar la transacción. Notifique a Soporte técnico.', {
                position: 'top-right', theme: 'colored', autoClose: false
            })
        } finally {
            setLoadingSubmitForm(false)
        }
    }

    useEffect(() => {
        _fetchMovementsByFilter(Forms.FilterMovements.formState)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return Object.freeze({
        handleChangeTab,
        handleChangeMovementStartDate,
        handleChangeMovementEndDate,
        handleChangeMovementIdbanco,
        handleChangeMovementTipoFilter,
        onSubmitFilterMovements,
        handleClickPrintMovementsReport,
        handleClickPrintMovementReceipt,
        handleChangeMovementAmount,
        handleChangeMovementCurrency,
        handleChangeMovementExchangeRate,
        handleClickOpenMovementForm,
        handleClickShowMovement,
        handleClickHideMovementForm,
        onSubmitMovementForm,
        handleChangeStartDate,
        handleChangeEndDate,
        handleChangeIdbanco,
        onSubmitFilterForm,
        handleClickShowDeposit,
        handleClickHideForm,
        handleClickDownloadBoleta,
        handleClickApproveDeposit,
        handleClickPrintBankReport,
    })
}
